const cacheKeys = {
  applicantCode: 'APPLICANT_STORAGE_KEY',
  adminRefreshTokenKey: 'ADMIN_REFRESH_TOKEN_STORAGE_KEY'
};

export default cacheKeys;
